import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

function socialFunction() {
	if($(".wp-block-thefuturblocks-social").length > 0) {
		$(".wp-block-thefuturblocks-social__profile").each(function() {
			var self = $(this),
				link = self.find('a'),
				span = self.find('span'),
				svg = self.find('svg'),
			    dataHoverColor = self.parent().attr("data-hcolor"),
			    tl = gsap.timeline({paused:true});

			if(span.length) {
				tl.to(span, {duration: 0.3, color:dataHoverColor});
			}
			if(svg.length) {
				tl.to(svg, {duration: 0.3, fill:dataHoverColor}, 0);
			}

			link.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		})
	}
}
socialFunction();